export namespace Settings
{

    // The estimated number of kilometers the average person
    // drives in one year.  Should not be used directly as the IVehicle has it's own property
    // for estimatedAnnualKilometers and that should be used instead.  This setting is a default
    // setting for when the vehicle's property has not been set.
    export const EstimatedAnnualKilometers = 15000; 

    // These are used to lookup a marketplace category by its name.  Category ID's can change
    // so this is needed to match marketplace categories that are not conditions.
    export const CategoryNameDictionary = new class 
    {
        readonly Fuel = 'Fuel';
        readonly RoadsideAssistance ='Roadside Assist';
    }

    export const Concierge = new class 
    {
        readonly HoursOfOperation = 'Monday to Friday, 9:00am to 5:00pm AEST';
        readonly PhoneNumber = '1800 131 318';
    }

    export const RoadsideAssistance = new class 
    {
        readonly PolicyNumber = 'CB/33864';
    }

}
